import React, {useEffect, useState} from "react";
import {Button, Divider, Modal, notification, Spin, Table} from "antd";
import {companyService} from "../../../services";
import './style.less'
import ModalChangeUserLogin from "../change-user-login";
import i18n from "i18next";

export default function ModalEmployeeListForConsignor({isShow, setIsShow, companyID}) {
  const [loading, setLoading] = useState(true);
  const [employeesList, setEmployeesList] = useState([]);
  const [needUpdate, setNeedUpdate] = useState(true);
  const [showUserChangeLoginModal, setShowUserChangeLoginModal] = useState(null);

  useEffect(() => {
    if (companyID && isShow && needUpdate) {
      setLoading(true);
      companyService.getEmployeeListForConsignor(companyID)
        .then(resp => {
          setEmployeesList(resp.Employees);
          setLoading(false);
          setNeedUpdate(false);
        })
        .catch((err) => {
          notification.error({
            message: i18n.t('components.notification.titles.getEmployeeListForConsignor'),
            description: err,
          });
        });
    }
  }, [companyID, isShow, needUpdate]);

  const columns = [

    {
      title: i18n.t('modals.modalEmployeeListForConsignor.table.employee.title'),
      key: 'mobile',
      render: (record) => (
        <>
          <b>{record.FirstName} {record.Patronymic} {record.SecondName}</b>
          <Divider>{i18n.t('modals.modalEmployeeListForConsignor.table.email.title')}</Divider>
          {record.Email}
          <Divider>{i18n.t('modals.modalEmployeeListForConsignor.table.phone.title')}</Divider>
          {record.Phone}
          <Divider>{i18n.t('modals.modalEmployeeListForConsignor.table.status.title')}</Divider>
          {record.Status}
          <Divider/>
          {record.Status !== "Удален" && <>
            <Button style={{marginLeft: "0px", width: "100%"}}
                    size="small"
                    className="small-button typical-btn-blue"
                    onClick={() => {
                      setShowUserChangeLoginModal(record.Id);
                    }}>
              {i18n.t('modals.modalEmployeeListForConsignor.buttons.changeLogin')}
            </Button>
            <ModalChangeUserLogin
              id={record.UserId}
              isShow={showUserChangeLoginModal === record.Id}
              setIsShow={() => {
                setShowUserChangeLoginModal(null)
              }}
              setNeedUpdateList={setNeedUpdate}
            />
          </>
          }
        </>
      ),
      className: "desktop-hidden"
    },
    {
      title: i18n.t('modals.modalEmployeeListForConsignor.table.fio.title'),
      key: 'fio',
      render: (record) => (
        <React.Fragment>
          {record.FirstName} {record.Patronymic} {record.SecondName}
        </React.Fragment>
      ),
      className: "mobile-hidden"
    },
    {
      title: i18n.t('modals.modalEmployeeListForConsignor.table.fio.title'),
      dataIndex: 'Email',
      key: 'email',
      className: "mobile-hidden"
    },
    {
      title: i18n.t('modals.modalEmployeeListForConsignor.table.phone.title'),
      dataIndex: 'Phone',
      key: 'phone',
      className: "mobile-hidden"
    },
    {
      title: i18n.t('modals.modalEmployeeListForConsignor.table.status.title'),
      dataIndex: 'Status',
      key: 'status',
      className: "mobile-hidden"
    },
    {
      title: '',
      key: 'action',
      className: "mobile-hidden",
      render: (record) => (
        record.Status !== "Удален" &&
        <>
          <Button style={{marginLeft: "0px", width: "100%"}}
                  size="small"
                  className="small-button typical-btn-blue"
                  onClick={() => {
                    setShowUserChangeLoginModal(record.Id);
                  }}>
            {i18n.t('modals.modalEmployeeListForConsignor.buttons.changeLogin')}
          </Button>
          <ModalChangeUserLogin
            id={record.UserId}
            isShow={showUserChangeLoginModal === record.Id}
            setIsShow={() => {
              setShowUserChangeLoginModal(null)
            }}
            setNeedUpdateList={setNeedUpdate}
          />
        </>
      )
    },
  ];

  return (
    <Modal
      title={i18n.t('modals.modalEmployeeListForConsignor.title')}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      onOk={() => {
        setIsShow(false);
      }}
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Table
          columns={columns}
          dataSource={employeesList}
          bordered={true}
          className={"employees-table"}
          rowKey={"Id"}
        />
      </Spin>
    </Modal>
  );
}
